<template>
  <div class="note">
    <p>{{ infoTitle }}</p>
    <ul>
      <template v-for="(info, idx) in infoList" :key="idx">
        <li v-if="info" v-html="info"></li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BaseInfo",
  props: {
    infoTitle: {
      type: String,
      default: "",
    },
    infoList: {
      type: Array,
    },
  },
};
</script>
